"use client";

import Script from "next/script";
import { usePathname } from "next/navigation";

/**
 * NICE CXone chat and guide widget.
 *
 * Skipped on the CSR popup windows. Those are opened with window.open from the
 * dashboard, so they load the root layout and would boot a second widget in the
 * same origin while the dashboard's is still running. Two instances contend for
 * the vendor's shared IndexedDB store, which surfaces as
 * `sharedIndexPutRecords('pageViews'): timeout` and `AbortError: The
 * transaction was aborted` from its storage iframe.
 *
 * Nothing in the app calls the `cxone` global, and the popups show a read-only
 * mirror of the customer view, so they have no use for the widget.
 */
const SKIP_PREFIXES = ["/cs-dashboard/popup-info"];

export function CXoneChat({ nonce }: { nonce?: string }) {
  const pathname = usePathname();

  if (SKIP_PREFIXES.some((prefix) => pathname?.startsWith(prefix))) {
    return null;
  }

  return (
    <Script id="cxone-chat-script" strategy="afterInteractive" nonce={nonce}>
      {`
            (function(n,u){
            window.CXoneDfo=n,
            window[n]=window[n]||function(){(window[n].q=window[n].q||[]).push(arguments)},window[n].u=u,
            e=document.createElement("script"),e.type="module",e.src=u+"?"+Math.round(Date.now()/1e3/3600),
            document.head.appendChild(e)
            })('cxone','https://web-modules-de-na1.niceincontact.com/loader/1/loader.js');

            cxone('init', '4627');
            cxone('guide','init');

            cxone('chat','hideQueueCounterAfterAssignment');
            cxone('chat','showTermsOfUse', 'Show terms of Use', 'externalLink' , 'https://www.dteenergy.com/us/en/quicklinks/terms-conditions.html');
            cxone('chat','setCaseCustomField', 'url', window.location.href);
            cxone('chat','setCustomCss', '[data-selector="HEADER"] {color: white !important; background: #0C2340 !important};');
            cxone('chat','setCustomCss', "[data-selector=\\"ACTIVITY_BAR\\"] {display: none !important}");
          `}
    </Script>
  );
}
